import styled from 'styled-components';

export const Container = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  width: max-content;
  color: var(--white);
  font-weight: 700;
  text-align: center;
  margin-bottom: 1.6rem;

  .gift-top {
    display: flex;
    flex-direction: column;
    background: var(--blue_light);
    border: 1px solid var(--blue_light);
    border-radius: 0.2rem;
    padding: 0.6rem 1.8rem;
    min-width: 10rem;
    text-transform: uppercase;
  }

  .gift-bottom {
    margin-top: 0.05rem;
    background: var(--gradient_green);
    border: 1px solid var(--white);
    border-radius: 0.2rem;
    width: 100%;
    line-height: 2rem;
    font-size: 0.9rem;
  }

  .gift-top:hover,
  .gift-bottom:hover {
    font-weight: 900;
    color: var(--primary_color);
    background-color: var(--white);
    background: var(--white);
    border: 1px solid var(--primary_color);
  }
`;
